import { useEffect, useState } from 'react';

import { fetchTestTabBrowseSections } from '@api/fetchers/goal/test-tab';
import type { BrowseSection } from '@api/fetchers/goal/test-tab/types';
import { normalizeBrowseSections } from '@cont/SeeAll/TestSeriesListing/testTab/browseSections';

interface UseTestTabBrowseCardsParams {
  goalUid?: string;
  language?: number;
  subscription?: string;
  enabled?: boolean;
}

const useTestTabBrowseCards = ({
  goalUid,
  language,
  subscription,
  enabled = true
}: UseTestTabBrowseCardsParams) => {
  const shouldFetch = Boolean(goalUid && enabled);
  const [sections, setSections] = useState<BrowseSection[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!goalUid || !enabled) {
      setSections([]);
      setIsLoading(false);
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      setIsLoading(true);

      try {
        const response = await fetchTestTabBrowseSections({
          goalUid,
          language,
          subscription
        });

        if (!cancelled) {
          setSections(normalizeBrowseSections(response));
        }
      } catch {
        if (!cancelled) {
          setSections([]);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [goalUid, language, subscription, enabled]);

  return {
    sections,
    isLoading: shouldFetch && isLoading
  };
};

export default useTestTabBrowseCards;
